var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"guild-popout-page"},[_c('div',_vm._l((_vm.guild.customStickers),function(sticker){return _c('img',{staticClass:"sticker",attrs:{"src":sticker.url}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }